import { render, staticRenderFns } from "./attention.vue?vue&type=template&id=6d00177f&scoped=true"
var script = {}
import style0 from "./attention.vue?vue&type=style&index=0&id=6d00177f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d00177f",
  null
  
)

export default component.exports